import React from "react";
import TbSetItemForm from "../../pages/InitialData/TbSetItem/Form";

const ItemModalAddItem = ({
  open,
  onClose,
  onCreated,
  formData,
  setFormData,
}) => {
  if (!open) return null;

  return (
    <>
      <div
        className={`modal ${open ? "show" : ""}`}
        style={{ display: open ? "block" : "none", zIndex: 1060 }}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ maxWidth: "980px", width: "95%" }}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: 12,
              overflow: "hidden",
              boxShadow: "0 10px 35px rgba(0,0,0,0.25)",
              background: "#ffffff",
            }}
          >
            <div
              className="modal-header"
              style={{ background: "#ffffff", borderBottom: "1px solid #eef0f3" }}
            >
              <h5 className="modal-title" style={{ fontWeight: 600, margin: 0 }}>
                สร้างสินค้าใหม่
              </h5>
              <button
                type="button"
                className="close"
                onClick={onClose}
                aria-label="Close"
                style={{ fontSize: "1.25rem", lineHeight: 1 }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                maxHeight: "calc(100vh - 180px)",
                overflowY: "auto",
                background: "#fff",
              }}
            >
              <TbSetItemForm
                callInitialize={onCreated}
                mode={"I"}
                name={"สร้างสินค้า"}
                formData={formData}
                setFormData={setFormData}
                selectedData={null}
                embedded={true}
                onBack={onClose}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1055 }}></div>
    </>
  );
};

export default ItemModalAddItem;
